
import {
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Checkbox,
    IconButton,
    Tooltip
} from "@mui/material";
import { CustomTitle } from "../../HelperFunctions/HelperFunctions";
import DeleteIcon from '@mui/icons-material/Delete';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';


const PeriodicReportTable = () => {

    
        const columns = [
            { name: "report_name", width: "120px" },
            { name: "report_book_name", width: "120px" },
            { name: "reports_included", width: "110px" },
            { name: "no_of_users", width: "65px" },
            { name: "report_month", width: "80px" },
            { name: "last_sent", width: "100px" },
            { name: "send", width: "100px" },
            { name: "schedule", width: "110px" },
            { name: "actions", width: "110px" },
        ];
    
        const data = [
            {
                report_name: "Profit & Loss - Standard",
                report_book_name: "Profit Report",
                reports_included: "This Month - to - Date",
                no_of_users: 8,
                report_month: "May - 2024",
                last_sent: "01-01-2025 05:00 AM",
            },
            {
                report_name: "Balance Sheet Summary",
                report_book_name: "Finance Report",
                reports_included: "Last Quarter",
                no_of_users: 10,
                report_month: "May - 2024",
                last_sent: "02-02-2025 10:00 AM",
            },
        ];

    return(

        <TableContainer sx={{ border: "1px solid #f2f2f2" }} >
        <Table size="small" stickyHeader>
            <TableHead>
                <TableRow sx={{ "& .MuiTableCell-stickyHeader": { bgcolor: "#d7d7d7" } }}>
                    <TableCell width="1px" sx={{ padding: "1px", borderRight: "1px solid white" }}>
                        <Checkbox size="small" color="grey" disableRipple />
                    </TableCell>
                    {columns.map((column, index) => (
                        <TableCell
                            key={index}
                            width={column.width}
                            sx={{ borderRight: "1px solid white", padding: 1, fontSize: "13px", fontWeight: 500 }}
                        >
                            {CustomTitle(column.name)}
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>

            <TableBody>
                {data.map((row, rowIndex) => (
                    <TableRow key={rowIndex}>
                        <TableCell sx={{ padding: "1px", borderRight: "1px solid #f2f2f2" }}>
                            <Checkbox size="small" color="grey" disableRipple />
                        </TableCell>

                        {columns.slice(0, 6).map((column, colIndex) => (
                            <TableCell
                                key={colIndex}
                                sx={{
                                    borderRight: "1px solid #f2f2f2",
                                    padding: "10px",
                                    fontSize: "12px",
                                    maxWidth: column.width,
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                }}
                            >
                                <Tooltip title={row[column.name] || "-"} arrow>
                                    <span>{row[column.name] || "-"}</span>
                                </Tooltip>
                            </TableCell>
                        ))}

                    
                        <TableCell sx={{ borderRight: "1px solid #f2f2f2", textAlign: "center" }}>
                            <Button
                                variant="contained"
                                size="small"
                                disableElevation
                                disableRipple
                                sx={{
                                    textTransform: "none",
                                    bgcolor: "#fbdbb1",
                                    color: "#b8741a",
                                    fontWeight: 700,
                                    fontSize: "10px",
                                }}
                            >
                                Re-Send Report
                            </Button>
                        </TableCell>
                        <TableCell sx={{ borderRight: "1px solid #f2f2f2", textAlign: "center" }}>
                            <Button
                                variant="contained"
                                size="small"
                                disableElevation
                                disableRipple
                                sx={{
                                    textTransform: "none",
                                    backgroundColor: "#82ffff",
                                    color: "#067db4",
                                    fontWeight: 700,
                                    fontSize: "10px",
                                }}
                            >
                                Update Schedule
                            </Button>
                        </TableCell>
                        <TableCell>
                            <IconButton size="small">
                                <BorderColorOutlinedIcon sx={{ color: "#00efd1" }} />
                            </IconButton>
                            <IconButton size="small">
                                <SimCardDownloadOutlinedIcon sx={{ color: "#00efd1" }} />
                            </IconButton>
                            <IconButton size="small">
                                <DeleteIcon sx={{ color: "#00efd1" }} />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
    );
}

export default PeriodicReportTable;
